import React from 'react';

import ContentLoader, { ContentLoaderProps } from './ContentLoader';

export interface ContentLoaderTypographyProps extends ContentLoaderProps {
  // TODO support different `Typography.variant` for `ContentLoaderTypography`
  // variant?:Typography['variant']
}

const ContentLoaderTypography: React.FC<ContentLoaderTypographyProps> = ({ ...rest }) => (
  <ContentLoader width={150} height={15} {...rest}>
    <rect x="0" y="0" rx="4" ry="4" width="80" height="15" />
  </ContentLoader>
);

export default ContentLoaderTypography;
